import { NavItem, NavLink } from "react-bootstrap";
import { Link } from "react-router-dom";

export const NavBarItem = ({ linkTo, eventKey, children, ...props }) => {
  return (
    <NavItem {...props}>
      <Link to={linkTo}>
        <NavLink as="div" eventKey={eventKey}>
          {children}
        </NavLink>
      </Link>
    </NavItem>
  );
};
